export default class Document {

  constructor() {
    this.title = ''
    this.description = ''
    this.file = ''
    this.expires_at = null
    this.asset_type_required_document_id = null
  }

}